<template>
  <div id="header-sidenav-menu">
    <slot></slot>
    <component
      :is="`sidenav_menu_01`"
      :config="styleMenu"
      :data="siteComponents"
      :is_public="isPreview"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";

const components = {
  sidenav_menu_01: () =>
    import(/* webpackChunkName: "sidenav_menu_01" */ "@components/header/widget/header_widget_menu/menu/menu_sidenav_view.vue"),
  
};

export default {
  props: {

  },
  components: {
    ...components,
  },
  computed: {
    ...mapGetters({
      isPreview: "designIframe/preview",
      siteComponents: "designIframe/metadata/siteComponents",
    }),
    styleMenu() {
      return this.siteComponents.HEADER_WIDGET_MENU.style;
    },
  },
  methods: {},
};
</script>

<style>

</style>
